import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'mtn-help-dashboard',
  templateUrl: './help-dashboard.component.html',
  styleUrls: ['./help-dashboard.component.scss']
})
export class HelpDashboardComponent {

  constructor() {
  }


}
